import React from"react";export var AuthContext=React.createContext(void 0);